import { Pipe, PipeTransform } from '@angular/core';
import { TemplateField } from '../../models/template.model';
import { DataObject } from '../../models/report.model';

@Pipe({ name: 'displayField' })
export class DisplayFieldPipe implements PipeTransform {
  transform(field: TemplateField, data: DataObject): boolean {
    // field condition and fieldDataToValidate were set in BE static json file for those attributes whose will need to be display based on lease type
    const fieldVal = data[field.fieldDataToValidate];
    const val = typeof fieldVal === 'string' ? fieldVal.toLowerCase() : fieldVal;
    return !!field.condition ? field.condition.toLowerCase() === val : true;
  }
}
